<template>
    <ul class="ul-column">
      <li class="make-and-model"><span>{{ quote.manufacturerName }}</span> {{ quote.modelName }}</li>
      <li class="description"><span class="key">{{ quote.derivativeName }}</span></li>
      <li class="quote-ref"><span class="key">Quote Ref:</span> <span class="value">{{quote.quoteNumber}}</span></li>
      <li class="quote-ref">
        <span class="key">Driver Grade:</span>
        <span class="value">{{driverGrade}}</span></li>
    </ul>
    <ul class="ul-row">
      <li class="contract-term">
        <span class="key">Contract Term</span>
        <span class="value">{{ quote.term }} months</span>
      </li>
      <li class="total-mileage">
        <span class="key">Annual Mileage</span>
        <span class="value">{{ quote.annualDistance }}</span>
      </li>
    </ul>
</template>

<script>
export default {
  name: "vehicle-meta",
  props: [
    'quote',
    'driverGradesById',
  ],
  computed: {
    driverGrade() {
      return this.driverGradesById?.[this.quote.quote.definition.driverGradeID].driverGradeDefinition.friendlyName ?? this.quote.quote.details.driverGradeName;
    }
  }
}
</script>

<style scoped>

</style>
